(function (window, angular, undefined) {
    var app = angular.module('formApp');
    app.directive("postcodeLookup", ['$http', 'FormService', '$timeout', 'LoadingInterceptor', function ($http, formService, $timeout, loadingInterceptor) {
        return {
            restrict: "A",
            require: "ngModel",
            link: function ($scope, element, attrs, ctrl) {
                
                // Add and event listener for the enter key
                  element.bind("keydown keypress", function (event) {
                    if(event.which === 13) {
                        event.preventDefault();
                        document.getElementById("findAddressBtn").click();
                        
                    }
                });

                $scope.selectedAddress = {};
                $scope.loading = false;

                ctrl.$validators.invalid = function (modelValue) {
                    ctrl.$setValidity('notfound', true);
                    return ctrl.$isEmpty(modelValue) || new RegExp('^([A-PR-UWYZ](([0-9](([0-9]|[A-HJKSTUW])?)?)|([A-HK-Y][0-9]([0-9]|[ABEHMNPRVWXY])?))\\s?[0-9][ABD-HJLNP-UW-Z]{2}|GIR 0AA)$').test(modelValue);
                };

                // $scope.showAddress = false;
                $scope.showAddressSelect = false;

                $scope.resetPostcode = function(){
                    setManualAddress();

                    if ($scope.address.show === true) {
                        $timeout(function() {
                            var focusAddress = document.getElementById('houseNameOrNumber');
                            focusAddress.focus();
                        });
                    }
                    
                };

                $scope.clearAddressId = function() {
                    setManualAddress();
                };

                function clearAddress() {
                    delete $scope.formData.aboutYou.houseNameOrNumber;
                    delete $scope.formData.aboutYou.street;
                    delete $scope.formData.aboutYou.addressLine2;
                    delete $scope.formData.aboutYou.town;
                    delete $scope.formData.aboutYou.county;
                    delete $scope.formData.aboutYou.addressId;
                }

                function setManualAddress() {
                    delete $scope.formData.aboutYou.addressId;
                    $scope.showAddressSelect = false;
                    $scope.formData.aboutYou.postCodeMethod = 'validManual';
                }
                
                // Create a function to call the postocde lookup
                $scope.fetchPostcode = function () {
                  
                    ctrl.$setValidity('notfound', true);
                    
                    var postcode = $scope.formData.aboutYou.postCode;
                    var params = {
                        operationType: 'search',
                        searchString: postcode
                    };
                    $scope.postcodecheck = true;
                    var patt = new RegExp('^([A-PR-UWYZ](([0-9](([0-9]|[A-HJKSTUW])?)?)|([A-HK-Y][0-9]([0-9]|[ABEHMNPRVWXY])?))\\s?[0-9][ABD-HJLNP-UW-Z]{2}|GIR 0AA)$', 'g');
                    var res = patt.test(postcode);

                  
                    if (res !== false) {
                        $scope.loading = true;
                        formService.getAddress(params).then(function success(response, status) {
                            $scope.loading = false;
                            if (response.data.type === 'multipleAddress') {
                                $scope.showAddressSelect = true;
                                $scope.address.show = false;
                                $scope.returnedAddressArray = response.data.postCodeSearchResult;
                                $scope.formData.aboutYou.postCodeMethod = 'auto';
                                $scope.selectedAddress = {};
                                clearAddress();
                            }
                            if (response.data.type === 'singleAddress') {
                                $scope.showAddressSelect = false;
                                $scope.address.show = false;
                                $scope.returnedAddress = response.data.postCodeSearchResult;
                                $scope.formData.aboutYou.postCode = $scope.returnedAddress.postCode;
                                $scope.formData.aboutYou.houseNameOrNumber = $scope.returnedAddress.buildingDesc;
                                $scope.formData.aboutYou.street = $scope.returnedAddress.street;
                                $scope.formData.aboutYou.addressLine2 = $scope.returnedAddress.street2;
                                $scope.formData.aboutYou.town = $scope.returnedAddress.postalTown;
                                $scope.formData.aboutYou.county = $scope.returnedAddress.county;
                                $scope.formData.aboutYou.postCodeMethod = 'auto';
                            }

                            if (response.data.status === 'failed') {
                   
                                //  ctrl.$setValidity('notfound', false);
                                $scope.formData.aboutYou.postCodeMethod = 'manual';
                                $scope.address.show = true;
                            }

                            if ($scope.showAddressSelect === true) {
                                $timeout(function() {
                                    var focusAddress = document.getElementById('addressList');
                                    focusAddress.focus();
                                });
                            }

                        }, function myError(response) {
                            // ctrl.$setValidity('notfound', false);
                            $scope.formData.aboutYou.postCodeMethod = 'manual';
                            $scope.address.show = true;
                            $scope.loading = false;
                        });
                    }
                };
                $scope.fetchAddress = function () {

                    var adRef = $scope.selectedAddress.address.addressLineReference;
                    var params = {
                        operationType: 'get',
                        searchString: adRef
                    };
                    loadingInterceptor.incrementRequests();
                    formService.getAddress(params).then(function success(response, status) {
                        loadingInterceptor.decrementRequests();
                        $scope.showAddressSelect = false;
                        $scope.returnedAddress = response.data.postCodeSearchResult;
                        $scope.formData.aboutYou.postCode = $scope.returnedAddress.postCode;
                        $scope.formData.aboutYou.houseNameOrNumber = $scope.returnedAddress.buildingDesc;
                        $scope.formData.aboutYou.street = $scope.returnedAddress.street;
                        $scope.formData.aboutYou.addressLine2 = $scope.returnedAddress.street2;
                        $scope.formData.aboutYou.town = $scope.returnedAddress.postalTown;
                        $scope.formData.aboutYou.county = $scope.returnedAddress.county;
                        $scope.formData.aboutYou.postCodeMethod = 'auto';
                        $scope.formData.aboutYou.addressId = response.data.addressId;
                        // $timeout(function() {
                        //     var focusAddress = document.getElementById('houseNameOrNumber');
                        //     focusAddress.focus();
                        // });

                    }, function myError(response) {
                        loadingInterceptor.decrementRequests();
                        $scope.address.show = true;
                        setManualAddress();
                    });
                };

            }
        };
    }]);
})(window, window.angular);
